import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['postSelect', 'slugDisplay']

  postChanged() {
    if (this.hasSlugDisplayTarget && this.hasPostSelectTarget) {
      const selectedOption = this.postSelectTarget.selectedOptions[0]
      this.slugDisplayTarget.textContent = selectedOption?.dataset?.slug || ''
    }
  }
}
